module.exports = __webpack_public_path__ + "static/img/logo.3ae24e04.png";